<template>
    <div class="logo-container">
      <img :src="logoSrc" alt="Sandor Vunk Logo" class="animated-logo" />
    </div>
  </template>
  
  <script>
  export default {
    name: 'AnimatedLogo',
    props: {
      isDarkMode: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      logoSrc() {
        return this.isDarkMode ? require('@/assets/sv_logo_light.svg') : require('@/assets/sv_logo_dark.svg');
      }
    }
  }
  </script>
  
  <style scoped>
  .logo-container {
    position: fixed;
    top: 30px;
    left: 30px;
    z-index: 1000;
  }
  
  .animated-logo {
    width: 110px;
    height: 110px;
  }
  
  @media (max-width: 768px) {
    .logo-container {
      top: 25px;
      left: 25px;
    }

    .animated-logo {
      width: 90px;
      height: 90px;
    }
  }
  </style>
